import React from "react";
import { Link } from "react-router-dom";

export default function UserListItem({ user }) {
  return (
    <article className="profile-card">
      <img className="avatar" src={user.avatar_url} alt={`${user.login} avatar`} />
      <div className="profile-card-body">
        <h3>{user.login}</h3>
        <p>Explore repositories and public activity.</p>
        <div className="search-actions">
          <Link className="primary-btn small" to={`/${user.login}`}>
            View profile
          </Link>
        </div>
      </div>
    </article>
  );
}
